import Typography from "@mui/material/Typography";
import type { SearchTemplateValue, TodoAssignmentCounts } from "../../api/";
import { AttentionBadge } from "./AttentionBadge";
import { BaseTodoBox } from "./BaseTodoBox";
import { TodoRoleChips } from "./TodoRoleChips";
import type { TodoHint } from "./todo-hints";
import { setClassNamesByCount } from "./utils";

export const AllNeedsAttention = ({
	needsAttention,
	readOnly = false,
	title,
	dataComponent,
	counts,
	hint,
}: {
	needsAttention: SearchTemplateValue;
	readOnly?: boolean;
	title: string;
	dataComponent?: string;
	/** When given, the item carries one link per role with a share of it. */
	counts?: TodoAssignmentCounts;
	hint?: TodoHint;
}) => {
	return (
		<BaseTodoBox
			dataComponent={dataComponent}
			className={setClassNamesByCount(needsAttention.count)}
			title={
				<AttentionBadge
					count={needsAttention.count}
					title={title}
					readOnly={readOnly}
					url={needsAttention.url}
				/>
			}
			description={
				<Typography variant="body1" component="div" color="textPrimary">
					Respond or mark as done
				</Typography>
			}
			to={needsAttention.url}
			readOnly={readOnly}
			hint={hint}
			subRow={
				counts ? (
					<TodoRoleChips
						counts={counts}
						kind="responses"
						baseUrl={needsAttention.url}
					/>
				) : undefined
			}
		/>
	);
};
